import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatLegacyProgressSpinnerModule as MatProgressSpinnerModule } from '@angular/material/legacy-progress-spinner';
import { NgbPopoverModule } from '@ng-bootstrap/ng-bootstrap';
import { NgSelectModule } from '@ng-select/ng-select';
import { NgxScannerQrcodeModule } from 'ngx-scanner-qrcode';

import { InventoryModule } from '@app/modules/inventory/inventory.module';
import { ScannerComponent } from '@app/modules/warehouse-mobile-app/scanner/scanner.component';
import { WarehouseScannerComponent } from '@app/modules/warehouse-mobile-app/warehouse-scanner/warehouse-scanner.component';
import { SharedModule } from '@app/shared/shared.module';
import { LuminousV2Module } from 'v2/luminous-v2.module';

import { CalculatorCounterComponent } from './calculator-counter/calculator-counter.component';
import { LoadingSpinnerComponent } from './loading-spinner/loading-spinner.component';
import { LocationScanComponent } from './location-scan/location-scan.component';
import { LocationSelectionComponent } from './location-selection/location-selection.component';
import { MobilePageComponent } from './mobile-page/mobile-page.component';
import { MultipleCounterComponent } from './multiple-counter/multiple-counter.component';
import { QuantityEntryComponent } from './quantity-entry/quantity-entry.component';
import { RfqSelectComponent } from './rfq-select/rfq-select.component';
import { SkuSelectionComponent } from './sku-selection/sku-selection.component';
import { TransferComponent } from './transfer/transfer.component';
import { WarehouseMobileAppRoutingModule } from './warehouse-mobile-app-routing.module';

@NgModule({
  declarations: [
    MobilePageComponent,
    LocationScanComponent,
    SkuSelectionComponent,
    WarehouseScannerComponent,
    ScannerComponent,
    QuantityEntryComponent,
    LocationSelectionComponent,
    MultipleCounterComponent,
    CalculatorCounterComponent,
    LoadingSpinnerComponent,
    RfqSelectComponent,
    TransferComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    WarehouseMobileAppRoutingModule,
    NgxScannerQrcodeModule,
    NgSelectModule,
    SharedModule,
    LuminousV2Module,
    NgbPopoverModule,
    InventoryModule,
    MatProgressSpinnerModule,
  ],
})
export class WarehouseMobileAppModule {}
